import active from '@/store/modules/pages/active'
import dots from '@/store/modules/pages/dots'

const initialState = () => ({
  all: []
})

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    assign(state, payload) {
      state.all = payload
    }
  },
  modules: {
    active,
    dots
  }
}
